import { render, staticRenderFns } from "./RestDayGrid.vue?vue&type=template&id=0a30d8e8"
import script from "./RestDayGrid.vue?vue&type=script&lang=js"
export * from "./RestDayGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports